import { styled, keyframes } from '@acko-tech/building-blocks.ui.common';

const sectionTitleSlideUp = () =>
  keyframes`
    0% {
      top: 0;
    }
    40% {
      top: -40px;
    }
    70% {
      top: -80px;
    }
    100% {
      top: -120px;
    }
  `;

export const SectionTitle = styled.div`
  font-weight: 700;
  font-size: 1.375rem;
  line-height: 2rem;
  margin-top: 6px;
  position: relative;
  font-family: 'EuclidCircular';
  animation: ${sectionTitleSlideUp()} 6s ease-in-out infinite;
  ${(props) => props && props.styles};
`;

export const SectionSubtitle = styled.div`
  font-family: 'EuclidCircular';
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 3px;
  text-transform: uppercase;
  padding: 0 0 20px 0;
  position: relative;
  z-index: 10;
  ${(props) => props && props.styles};
`;

export const NoResultsText = styled.div`
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-family: 'EuclidCircular';
  color: rgb(91, 86, 117);
  margin: 16px 0 0 0;
  ${(props) => props && props.styles};
`;

export const HeaderImage = styled.div`
  background: url(${(props) => props.img});
  background-repeat: no-repeat;
  background-size: cover;
  width: ${(props) => props.width || '100%'};
  max-width: inherit;
  height: 280px;
  position: relative;
`;

export const Gradient = styled.div`
  background: linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 1));
  width: 100%;
  max-width: inherit;
  height: 120px;
  position: absolute;
  bottom: 4px;
  z-index: 10;
`;

export const PopularTitle = styled.div`
  font-weight: 600;
  font-size: 1.125rem;
  font-family: 'EuclidCircular';
  line-height: 1.5rem;
  margin: 32px 0 16px 0;
`;

export const Filters = styled.div`
  display: flex;
  gap: 15px;
  padding: 0 0 24px 0;
  overflow: auto;
`;

export const FilterPill = styled.div`
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1.25rem;
  font-family: 'EuclidCircular';
  padding: 10px 0;
  border: 1px solid #000000;
  border-radius: 25px;
  min-width: 120px;
  text-align: center;
  background: ${(props) => (props.active ? '#040222' : '#ffffff')};
  color: ${(props) => (!props.active ? '#040222' : '#ffffff')};
  cursor: pointer;
`;

export const BackIcon = styled.div`
  position: absolute;
  top: 16px;
  left: 20px;
  z-index: 10;
`;

export const Section = styled.div`
  position: relative;
  top: -40px;
  max-width: 480px;
  width: 100%;
`;

export const CardsContainer = styled.div``;

export const Searchbar = styled.div`
  box-shadow: 0px 6px 12px -2px rgba(54, 53, 76, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border: 1px solid rgba(224, 224, 232, 1);
  border-radius: 8px;
  margin-top: 24px;
  cursor: pointer;
  background: white;

  @media screen and (min-width: 760px) {
    gap: 12px;
  }
`;

export const SearchText = styled.div`
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-family: 'EuclidCircular';
  color: rgba(91, 86, 117, 0.8);

  @media screen and (min-width: 760px) {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
`;

export const BoldText = styled.div`
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.5rem;
  font-family: 'EuclidCircular';
  padding: ${(props) => props?.padding || '30px 0 10px 0'};
`;

export const Tracker = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  background: rgba(248, 247, 252, 1);
  margin: 0 0 8px 0;
`;

export const TrackerInfo = styled.div``;

export const PrimaryText = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1rem;
  color: rgba(4, 2, 34, 1);
  font-family: 'EuclidCircular';
  ${(props) => props && props.styles};
`;

export const SecondaryText = styled.div`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  font-family: 'EuclidCircular';
  color: rgba(91, 86, 117, 1);
  ${(props) => props && props.styles};
`;

export const NoteSection = styled.div`
  padding: 24px 20px;
  width: 100%;
`;

export const Note = styled.div`
  box-shadow: 0px 0px 12px 0px rgba(54, 53, 76, 0.08);
  padding: 16px 20px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
`;

export const Separator = styled.div`
  border-top: 0.5px solid rgb(224, 224, 232);
  padding: 0 20px 24px 20px;
  width: 100%;
`;

export const BenefitsContainer = styled.div`
  width: 100%;
  padding: 24px 20px 180px 20px;
`;

export const BenefitsSection = styled.div`
  width: 100%;
  background: rgba(248, 247, 252, 1);
  padding: 16px;
  border-radius: 16px;
`;

export const Benefits = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
  row-gap: 12px;
  padding: 12px 0 0 0;
`;

export const Benefit = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Footer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 480px;
`;

export const FooterCta = styled.div`
  width: 100%;
  padding: 24px 20px;
  background: #ffffff;
  box-shadow: 0px -4px 8px -2px rgba(54, 53, 76, 0.06);
`;

export const SecondaryCta = styled.div`
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-family: 'EuclidCircular';
  color: ${(props) => (props?.mandatory ? '#040222' : '#1b73e8')};
  text-align: center;
  margin-top: 16px;
  cursor: pointer;
  opacity: ${(props) => (props?.mandatory ? '0.4' : '1')};
`;

export const MandatoryNudge = styled.div`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  color: rgba(4, 2, 34, 1);
  background: rgba(251, 234, 234, 1);
  padding: 8px 16px;
  border-radius: 10px;
  margin: 16px 0 0 20px;
  min-width: 300px;
  font-family: 'EuclidCircular';
`;

export const SearchBar = styled.div`
  color: rgb(91, 86, 117);
  width: 100%;
  background: ${(props) =>
    props?.focus ? 'rgb(255, 255, 255)' : 'rgb(248, 247, 252)'};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 46px;
  border: ${(props) =>
    props?.focus ? '1px solid' : '1px solid rgb(248, 247, 252)'};
  padding: 16px;

  @media screen and (min-width: 760px) {
    color: 040222;
  }
`;

export const Input = styled.input`
  width: 100%;
  background: ${(props) => (props?.focus ? 'white' : '#f8f7fc')};
  border-radius: 8px;
  outline-style: none;
  border: none;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.25rem;
  font-family: 'EuclidCircular';
  color: rgba(4, 2, 34, 1);

  ::placeholder,
  ::-webkit-input-placeholder {
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.25rem;
    opacity: 0.8;
  }
  :-ms-input-placeholder {
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.25rem;
    opacity: 0.8;
  }

  @media screen and (min-width: 760px) {
    color: 040222;
  }
`;

export const BackIconContainer = styled.div`
  cursor: pointer;
  padding: 4px 2px 0 15px;
`;

export const ClearIcon = styled.div`
  cursor: pointer;
  padding-top: 4px;
`;

export const CountryList = styled.div`
  overflow: auto;
  padding: 24px 0;
  height: calc(100vh - 240px);

  @media screen and (min-width: 760px) {
    width: 480px;
    height: calc(100vh - 400px);
    color: 040222;
  }
`;

export const CountryName = styled.div`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.375rem;
  font-family: 'EuclidCircular';
  padding: 16px 0;
  cursor: pointer;
`;

export const ErrorMessage = styled.div`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  font-family: 'EuclidCircular';
  color: rgb(91, 86, 117);
`;

export const TitleGroup = styled.div`
  height: 32px;
  overflow: hidden;
`;

export const NoResult = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 60px;
  padding: 0 20px;
`;

export const HeaderBanner = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

export const UspList = styled.div`
  width: 100%;
  padding: 0 20px;
  position relative;
  margin-bottom: 32px;
`;

export const FlightImageContainer = styled.div`
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-bottom: 4px solid white;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid rgb(231, 231, 240);
`;

export const PageContainer = styled.div`
  padding: 0 20px;
  width: 100%;
`;

export const DiscountCard = styled.div`
  position: relative;
  border: 1px solid #b191ed;
  background: #f8f5ff;
  border-radius: 12px;
  padding: 14px 12px 12px 12px;
  width: 100%;
`;

export const DiscountInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const DiscountCardTitle = styled.div`
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
`;

export const OfferTag = styled.div`
  background: linear-gradient(90deg, #2e74de -7.76%, #ad57e1 86.08%);
  color: rgb(255, 255, 255);
  font-size: 0.625rem;
  line-height: 0.875rem;
  font-weight: 500;
  padding: 2px 6px;
  text-align: center;
  border-radius: 20px;
  position: absolute;
  left: 12px;
  top: -9px;
`;
